$(() => {
  let currentTab;

  const modal = $('#reportMultipleSongs');

  const btnSkuConfirm = modal.find('#btnSkuConfirm');
  const btnSkuCheck = modal.find('#btnSkuCheck');
  const btnSkuBack = modal.find('.btnSkuBack');
  const btnSkuSubmit = modal.find('#btnSkuSubmit');

  const weekSelect = modal.find('.select-reportForWeek');
  const licenseSelect = modal.find('.select-licenseType');

  const currentWeek = $('.select-reportForWeek').val();

  let titles = [];

  function submitSkuReport() {
    const form = modal.find('#skuListForm');
    const dataArr = form.serializeArray();
    const btn = $(this);

    btn.loading();
    $.post(urlCheckSku, dataArr, (res) => {
      if (!res.isError) {
        if (res.count === 0) {
          btnSkuConfirm.attr('disabled', true);
        } else {
          btnSkuConfirm.attr('disabled', false);
        }

        titles = res.titles;
        modal.find('#skuTable').html(res.html);
        showTab('skuConfirm');
      } else {
        toastr.error(res.msgError);
      }
    }).always(() => {
      btn.loading('reset')
    });
  }

  function confirmSkuReport() {
    showTab('skuSubmit');
  }

  function backToForm() {
    if (currentTab === 'skuConfirm') {
      showTab('skuForm');
    } else {
      showTab('skuConfirm');
    }
  }

  function saveReport() {
    const form = modal.find('#reportForm');
    const dataArr = form.serializeJson();
    const btn = $(this);
    let selectedWeek = '';

    selectedWeek = dataArr.weeks;

    btn.loading();
    $.post(urlReportTitles, {
      dataArr,
      titles
    }, (res) => {
      if (!res.isError) {
        if (res.count === 0) {
          btnSkuConfirm.attr('disabled', true);
        } else {
          btnSkuConfirm.attr('disabled', false);
        }

        modal.find('#skuTable').html(res.html);
        modal.modal('hide');

        toastr.success(__('Songs reported successfuly'));

        if (currentWeek === selectedWeek && !('flash' in res)) {
          location.reload();
        }
      } else {
        toastr.error(res.msgError);
      }
    }).always(() => {
      btn.loading('reset');
    });
  }

  function licenseTypeSelect() {
    const selectedOption = $(this).find('option:selected');
    const id = selectedOption.val();
    const reprint = selectedOption.data('is-reprint');
    const master = selectedOption.data('is-master');
    const reprintAndMaster = reprint && master;
    const reprintServices = modal.find('.reprint-services');
    const masterServices = modal.find('.master-services');
    const streamedEventsEl = modal.find('#streamed_events');
    const recordingOptionEl = modal.find('#recording_option');
    const reprintServicesEmptyOption = streamedEventsEl.find('option[value="0"]');
    const masterServicesEmptyOption = recordingOptionEl.find('option[value="0"]');

    reprintServicesEmptyOption.prop('disabled', reprint && !reprintAndMaster);
    masterServicesEmptyOption.prop('disabled', master && !reprintAndMaster);

    weekSelect.select2({
      disabled: true,
      minimumResultsForSearch: Infinity,
      placeholder: __('loading...')
    });

    $.post(loadWeeksUrl, {
      id
    }, (data) => {
      weekSelect.find('option').remove();

      $.each(data.weeks, (i, item) => {
        weekSelect.append($('<option>', {
          value: i,
          text: item
        }));
      });

      weekSelect.select2({
        disabled: false,
        minimumResultsForSearch: Infinity
      });
    }, 'json');
  }

  function showTab(tab, callback) {
    if (currentTab !== tab) {
      modal.find(`.sku-report-tabs a.hidden[href="#${tab}"]`).tab('show');
      currentTab = tab;
    }
  }

  function prepareLicenseSelect() {
    licenseSelect.trigger('change').trigger('select2:select');

    if (licenseSelect.find('option').length === 1) {
      licenseSelect.parent().hide();
    }
  }

  modal.on('show.bs.modal', (e) => {
    if (licenseSelect.length) {
      weekSelect.html('');
    }

    btnSkuConfirm.removeClass('disabled');
    showTab('skuForm');
    prepareLicenseSelect();
  });

  licenseSelect.select2({
    placeholder: __('Select License Type'),
    minimumResultsForSearch: Infinity
  });

  if (licenseSelect.length) {
    weekSelect.html('');
    weekSelect.select2({
      placeholder: __('Select Week'),
      minimumResultsForSearch: Infinity,
      disabled: true
    });
  } else {
    weekSelect.select2({
      placeholder: __('Select Week'),
      minimumResultsForSearch: Infinity

    });
  }

  btnSkuCheck.click(submitSkuReport);
  btnSkuConfirm.click(confirmSkuReport);
  btnSkuBack.click(backToForm);
  btnSkuSubmit.click(saveReport);
  licenseSelect.on('select2:select', licenseTypeSelect);
});
